import { ELegalIdType, ERegion } from '@constants';
import { Select } from 'antd';
import { useTranslation } from 'react-i18next';

interface LegalIdTypeSelectorProps {
  value?: ELegalIdType;
  onChange?: (value: ELegalIdType) => void;
  placeholder?: string;
  disabled?: boolean;
  region?: ERegion;
}

export const LegalIdTypeSelector: React.FC<LegalIdTypeSelectorProps> = ({
  value,
  onChange,
  placeholder,
  disabled = false,
  region = ERegion.ES
}) => {
  const { t } = useTranslation('DefaultTranslations');

  const getLegalIdOptions = () => {
    const passportOption = {
      value: ELegalIdType.PASSPORT_OTHER,
      label: t(ELegalIdType.PASSPORT_OTHER)
    };

    return [
      { value: ELegalIdType.DNI_NIF_NIE, label: region === ERegion.PT ? 'CC' : 'DNI/NIF/NIE' },
      passportOption
    ];
  };

  const options = getLegalIdOptions();

  return (
    <Select
      value={value}
      onChange={onChange}
      options={options}
      placeholder={placeholder || t('SELECT_DOCUMENT_TYPE')}
      disabled={disabled}
      style={{ width: '100%' }}
    />
  );
};
